import { Text, Button } from '@tectonicfi/tectonic-ui-kit';

import Card from '@components/Card';
import useWallets from '@hooks/useWallets';

// * it's a grid item
function YourSupplyBorrowPlaceholderCard(): JSX.Element {
  const { onShowConnectWalletModal } = useWallets();
  return (
    <Card
      className="flex flex-col items-center gap-2 text-center desktop:col-span-2"
      padding="large"
    >
      <Text variant="heading3">Your supply / borrow</Text>
      <Text>Connect your wallet to see your supply / borrow assets</Text>
      <Button onClick={onShowConnectWalletModal}>Connect wallet</Button>
    </Card>
  );
}

export default YourSupplyBorrowPlaceholderCard;
